<template>
    <div class="row">
        <!-- <div class="col-md-12">
            <h1 class="h3 mb-3 text-gray-800">
                Referências/Contrarreferências: Família ID #{{
                    $route.params.id
                }}
            </h1>
        </div>
        <load v-if="loading" /> -->
        <header-servico
            tipo="Referências/Contrarreferências"
            :loading="loading"
            :familia="familia.id"
        />
        <load
            v-if="loading"
            message="Carregando as Referências/Contrarreferências da Família"
        />
        <div v-else class="col-md-12">
            <!--Tabela-->
            <div class="row">
                <sidebar-servicos active="referencia" />

                <div class="col-md-9">
                    <div class="row">
                        <div class="col-md-12">
                            <header-familia :item="familia" />
                        </div>
                    </div>
                    <div class="card mb-0 shadow">
                        <div class="card-body">
                            <div class="tab-content">
                                <div
                                    v-if="!nova_referencia"
                                    class="animate__animated animate__fadeIn"
                                >
                                    <div class="row">
                                        <!-- <div class="col">
                                            <div
                                                class="d-flex align-items-center justify-content-between mb-4"
                                            >
                                                <h5 class="font-weight-bold">
                                                    Referências/Contrarreferências
                                                </h5>
                                            </div>
                                        </div> -->
                                        <div class="col-12">
                                            <div
                                                class="d-flex align-items-center justify-content-between mb-4"
                                            >
                                                <div>
                                                    <button
                                                        class="btn btn-primary"
                                                        @click="
                                                            nova_referencia = true
                                                        "
                                                    >
                                                        <i
                                                            class="fas fa-plus-square"
                                                        />
                                                        {{ $t("Cadastrar") }}
                                                    </button>
                                                </div>
                                                <div>
                                                    <b-button-group>
                                                        <b-button
                                                            variant="outline-dark"
                                                            :class="
                                                                viewFilterReport ===
                                                                true
                                                                    ? 'active'
                                                                    : ''
                                                            "
                                                            @click="viewFilters"
                                                        >
                                                            <i
                                                                class="fas fa-filter"
                                                            ></i>
                                                            {{ $t("Filtros") }}
                                                        </b-button>
                                                        <b-button
                                                            variant="outline-dark"
                                                            @click="print()"
                                                        >
                                                            <i
                                                                class="fas fa-print"
                                                            ></i>
                                                        </b-button>
                                                    </b-button-group>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div
                                            class="col-12"
                                            v-if="viewFilterReport"
                                        >
                                            <form
                                                @submit.prevent="getReferencias"
                                                ref="formFiltros"
                                            >
                                                <div class="row">
                                                    <form-select
                                                        v-model="filtroPessoas"
                                                        :multiple="true"
                                                        label="Usuário(s)"
                                                        :itens="pessoas"
                                                        grid="12"
                                                    />

                                                    <form-calendar
                                                        v-model="data_inicio"
                                                        grid="4"
                                                        label="Data Inicial"
                                                    />

                                                    <form-calendar
                                                        v-model="data_fim"
                                                        grid="4"
                                                        label="Data Final"
                                                        :required="
                                                            verificaDataInicial
                                                        "
                                                    />

                                                    <form-select
                                                        v-model="filtroStatus"
                                                        label="Status"
                                                        :itens="status"
                                                        grid="4"
                                                    />

                                                    <div class="col-md-12">
                                                        <label
                                                            ><b
                                                                >Pesquisar</b
                                                            ></label
                                                        >
                                                        <div
                                                            class="input-group"
                                                        >
                                                            <b-input
                                                                placeholder="Protocolo, Origem, Técnico, Unidade de Intervenção e Técnico de Intervenção"
                                                                class="form-control search-input"
                                                                type="text"
                                                                v-model="search"
                                                                aria-describedby="input-search"
                                                            />
                                                            <div
                                                                class="input-group-append"
                                                                role="button"
                                                                @click.prevent="
                                                                    getReferencias
                                                                "
                                                            >
                                                                <span
                                                                    class="input-group-text"
                                                                    id="input-search"
                                                                    ><i
                                                                        class="fas fa-search search-icon"
                                                                /></span>
                                                            </div>
                                                        </div>
                                                        <p
                                                            class="small text-muted"
                                                        >
                                                            Através do campo
                                                            acima você pode
                                                            pesquisar por:
                                                            Protocolo, Origem,
                                                            Técnico, Unidade de
                                                            Intervenção e
                                                            Técnico de
                                                            Intervenção
                                                        </p>
                                                    </div>
                                                </div>
                                                <div
                                                    class="row pt-2 mb-4 px-0 d-flex justify-content-end"
                                                >
                                                    <div
                                                        class="col-auto px-2 text-right"
                                                    >
                                                        <button
                                                            class="btn btn-default btn-sm"
                                                            @click.prevent="
                                                                limparFiltros();
                                                                viewFilterReport = false;
                                                            "
                                                        >
                                                            <i
                                                                class="fas fa-times"
                                                            ></i>
                                                        </button>

                                                        <button
                                                            type="button"
                                                            class="btn btn-secondary btn-sm"
                                                            @click.prevent="
                                                                limparFiltros()
                                                            "
                                                        >
                                                            {{
                                                                $t(
                                                                    "Limpar Filtros"
                                                                )
                                                            }}
                                                        </button>
                                                        <button
                                                            class="btn btn-success btn-submit btn-sm"
                                                            data-style="zoom-in"
                                                            type="submit"
                                                        >
                                                            <i
                                                                class="fas fa-chart-bar"
                                                            ></i>
                                                            {{ $t("Filtrar") }}
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        <load
                                            mode="table"
                                            v-if="loadingReferencias"
                                        />
                                        <div class="col-12" v-else>
                                            <span>
                                                <a v-if="!showName" @click.prevent="mostrarNome" href="#"><i class="fas fa-eye"></i> Mostrar Nome de Registro</a> 
                                                <a v-else @click.prevent="ocultarNome" href="#"><i class="fas fa-eye-slash"></i> Ocultar Nome de Registro</a> 
                                            </span>
                                            <print-content>
                                                <b-table
                                                    :fields="[
                                                        {
                                                            key: 'protocolo',
                                                            label: $t(
                                                                'Detalhes'
                                                            ),
                                                        },
                                                        {
                                                            key: 'cadastrado',
                                                            label: $t('Data'),
                                                        },
                                                        {
                                                            key: 'status_nome',
                                                            label: $t('Status'),
                                                        },
                                                        {
                                                            key: 'actions',
                                                            label: '',
                                                            class: 'text-right no-print',
                                                            thStyle: {
                                                                width: '95px',
                                                                minWidth:
                                                                    '95px',
                                                            },
                                                        },
                                                    ]"
                                                    :items="referenciasList"
                                                    :responsive="true"
                                                    striped
                                                    hover
                                                    show-empty
                                                    small
                                                    outlined
                                                    stacked="xs"
                                                    table-class="mb-3"
                                                >
                                                    <template
                                                        v-slot:cell(protocolo)="data"
                                                    >
                                                        Usuário(s):<br />
                                                        <ul>
                                                            <li
                                                                v-for="pessoa in data
                                                                    .item
                                                                    .pessoas_objetos"
                                                                :key="pessoa.id"
                                                            >
                                                            <strong v-if="!pessoa.nome_social" v-html="$options.filters.highlight(pessoa.nome_completo,search)" ></strong>
                                                            <span v-else>
                                                                <strong>{{ pessoa.nome_social }} ( N.R.: ) </strong>
                                                                <strong v-if="showName" v-html="$options.filters.highlight(pessoa.nome_completo,search)" ></strong> 
                                                            </span>
                                                            </li>
                                                        </ul>

                                                        Protocolo:
                                                        <strong
                                                            v-html="
                                                                $options.filters.highlight(
                                                                    data.item
                                                                        .protocolo,
                                                                    search
                                                                )
                                                            "
                                                        ></strong>

                                                        <span
                                                            v-if="
                                                                data.item
                                                                    .unidade
                                                            "
                                                        >
                                                            <br />
                                                            Origem:
                                                            <strong
                                                                v-html="
                                                                    $options.filters.highlight(
                                                                        data
                                                                            .item
                                                                            .unidade
                                                                            .nome,
                                                                        search
                                                                    )
                                                                "
                                                            ></strong>
                                                        </span>

                                                        <span
                                                            v-if="
                                                                data.item.user
                                                                    .name
                                                            "
                                                        >
                                                            <br />
                                                            Técnico autor:
                                                            <strong
                                                                v-html="
                                                                    $options.filters.highlight(
                                                                        data
                                                                            .item
                                                                            .autor,
                                                                        search
                                                                    )
                                                                "
                                                            ></strong>
                                                        </span>

                                                        <span
                                                            v-if="
                                                                data.item
                                                                    .unidade_destino
                                                            "
                                                        >
                                                            <br />
                                                            Unidade de
                                                            Intervenção:
                                                            <strong
                                                                v-html="
                                                                    $options.filters.highlight(
                                                                        data
                                                                            .item
                                                                            .unidade_destino
                                                                            .nome,
                                                                        search
                                                                    )
                                                                "
                                                            ></strong>
                                                        </span>

                                                        <span
                                                            v-if="
                                                                data.item
                                                                    .user_destino
                                                            "
                                                        >
                                                            <br />
                                                            Técnico na Unidade
                                                            de Intervenção:
                                                            <strong
                                                                v-html="
                                                                    $options.filters.highlight(
                                                                        data
                                                                            .item
                                                                            .user_destino
                                                                            .name,
                                                                        search
                                                                    )
                                                                "
                                                            ></strong>
                                                        </span>
                                                        <br />
                                                        Tipo:
                                                        <b
                                                            v-if="
                                                                data.item
                                                                    .tipo_nome ==
                                                                'REFERÊNCIA'
                                                            "
                                                        >
                                                            <span
                                                                class="badge badge-primary"
                                                            >
                                                                {{
                                                                    data.item
                                                                        .tipo_nome
                                                                }}
                                                            </span>
                                                        </b>
                                                        <b v-else>
                                                            <span
                                                                class="badge badge-info"
                                                            >
                                                                {{
                                                                    data.item
                                                                        .tipo_nome
                                                                }}
                                                            </span>
                                                        </b>
                                                        <span class="d-block">
                                                            <i
                                                                class="mdi mdi-lock mdi-18px text-danger"
                                                                v-if="
                                                                    data.item
                                                                        .privado ==
                                                                    1
                                                                "
                                                                v-b-popover.hover.top="
                                                                    'Item Sigiloso'
                                                                "
                                                            ></i>
                                                        </span>
                                                    </template>
                                                    <template
                                                        v-slot:cell(cadastrado)="data"
                                                    >
                                                        {{
                                                            data.item.cadastrado
                                                        }}
                                                    </template>
                                                    <template
                                                        v-slot:cell(status_nome)="data"
                                                    >
                                                        <span
                                                            class="small"
                                                            v-html="
                                                                data.item
                                                                    .status_nome
                                                            "
                                                        ></span>
                                                    </template>
                                                    <template
                                                        v-slot:cell()="data"
                                                    >
                                                        <b-button
                                                            v-if="
                                                                (unidade_id ==
                                                                    data.item
                                                                        .unidade_id ||
                                                                unidade_id ==
                                                                    data.item
                                                                        .unidade_destino_id) &&
                                                                ($store.state.user.role_details.name == 'Coordenador' || $store.state.user.role_details.name == 'Gestor(a)' || $store.state.user.role_details.name == 'Técnico(a) de Nível Superior' ||
                                                                    $store.state.user.name == data.item.user.name || $store.state.user.name == data.item.user_destino.name
                                                                )
                                                            "
                                                            :title="
                                                                $t(
                                                                    'Visualizar e Imprimir'
                                                                )
                                                            "
                                                            :to="
                                                                '/dashboard/referenciamentos/show/' +
                                                                data.item.id
                                                            "
                                                            class="px-2 mb-0"
                                                            size="xs"
                                                            type="button"
                                                            v-b-tooltip.hover
                                                            variant="primary"
                                                        >
                                                            <i
                                                                class="mdi mdi-eye"
                                                            />
                                                        </b-button>
                                                    </template>
                                                    <template
                                                        v-slot:empty="scope"
                                                    >
                                                        <div
                                                            class="text-center my-5"
                                                        >
                                                            <img
                                                                :alt="
                                                                    $t(
                                                                        'No results'
                                                                    )
                                                                "
                                                                class="mb-5"
                                                                src="/img/icons/robot.svg"
                                                                style="
                                                                    max-height: 165px;
                                                                "
                                                            />
                                                            <h3 class="bold">
                                                                {{
                                                                    $t(
                                                                        "No records found"
                                                                    )
                                                                }}
                                                            </h3>
                                                        </div>
                                                    </template>
                                                </b-table>
                                            </print-content>
                                            <div
                                                class="row align-items-center no-print"
                                            >
                                                <div class="col-lg-6 col-md-12">
                                                    <div
                                                        class="form-group d-inline-flex mb-0"
                                                    >
                                                        <select
                                                            class="form-control"
                                                            style="width: 70px"
                                                            v-model="perPage"
                                                            v-on:change="
                                                                getReferencias
                                                            "
                                                        >
                                                            <option value="5">
                                                                5
                                                            </option>
                                                            <option value="10">
                                                                10
                                                            </option>
                                                            <option value="25">
                                                                25
                                                            </option>
                                                            <option value="50">
                                                                50
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div
                                                        class="d-inline-flex ml-2"
                                                    >
                                                        <b-pagination
                                                            :per-page="perPage"
                                                            :total-rows="
                                                                pagination.total
                                                            "
                                                            @change="changePage"
                                                            v-model="page"
                                                        />
                                                    </div>
                                                </div>
                                                <div
                                                    class="col-lg-6 col-md-12 mt-4 mt-lg-0"
                                                >
                                                    <div class="float-lg-right">
                                                        {{ $t("Showing page") }}
                                                        {{
                                                            pagination.currentPage
                                                        }}
                                                        {{ $t("of") }}
                                                        {{
                                                            pagination.totalPages
                                                        }}
                                                        {{ $t("pages in") }}
                                                        {{ pagination.total }}
                                                        {{ $t("records") }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <NovaReferencia
                                    v-else
                                    :familia="familia"
                                    @voltar="nova_referencia = false"
                                    @reload="getReferencias"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import NovaReferencia from "./Add";
export default {
    components: { NovaReferencia },
    name: "ReferenciaContrarReferencia",
    metaInfo() {
        return {
            title: this.$i18n.t("Referência/Contrarreferência"),
        };
    },
    data() {
        return {
            showName: false,
            familia: {},
            nova_referencia: false,
            referenciasList: [],
            page: 1,
            search: "",
            perPage: 10,
            loadingReferencias: true,
            loading: true,
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0,
            },
            user_id: null,
            tecnico_id: null,
            unidade_id: null,
            status: [],
            filtroPessoas: [],
            filtroStatus: null,
            filtroDatas: [],
            loadingSearchTecnicos: true,
        };
    },
    computed: {
        pessoas() {
            // this.getTecnicos();

            const pessoas = this.familia.familiares ?? [];

            const map = pessoas.map((elem) => ({
                id: elem.id,
                value:
                    elem.posicao_familiar == 1
                        ? "<b>RF - </b> " +
                          elem.nome_completo +
                          " <b>" +
                          elem.idade +
                          " ano(s)</b>"
                        : elem.nome_completo +
                          " <b>" +
                          elem.idade +
                          " ano(s)</b>",
            }));
            return map;
        },
    },
    mounted() {
        this.getStatus();
        this.$route.query.familia_id = this.$route.params.id;
        if (typeof this.$route.query.item === "object") {
            this.familia = this.$route.query.item;
        } else {
            this.getFamilia();
        }
        this.getReferencias();
    },

    methods: {
        mostrarNome() {
            this.showName = true;
        },
        ocultarNome() {
            this.showName = false;
        },
        getReferencias(referencias_recebidas = null) {
            this.filtroDatas = [];
            if (this.data_inicio) {
                this.filtroDatas = this.filtroDatas.concat(
                    this.$options.filters.formatDateYMD(this.data_inicio)
                );
            }
            if (this.data_fim) {
                this.filtroDatas = this.filtroDatas.concat(
                    this.$options.filters.formatDateYMD(this.data_fim)
                );
            }

            this.loadingReferencias = true;
            axios
                .get("api/dashboard/referenciamentos", {
                    params: {
                        id: this.$route.params.id,
                        page: this.page,
                        search: this.search,
                        perPage: this.perPage,
                        referencias_recebidas: referencias_recebidas
                            ? referencias_recebidas
                            : 1,
                        filtroPessoas: this.filtroPessoas,
                        filtroStatus: this.filtroStatus,
                        filtroDatas: this.filtroDatas,
                    },
                })
                .then((response) => {
                    this.user_id = this.$store.state.user.id;
                    this.tecnico_id = this.$store.state.user.tecnico.id;
                    this.unidade_id = this.$store.state.unidade;
                    this.referenciasList = response.data.data;
                    this.pagination = response.data.pagination;

                    if (
                        this.pagination.totalPages < this.pagination.currentPage
                    ) {
                        this.page = this.pagination.totalPages;
                        this.getReferencias();
                    } else {
                        this.loadingReferencias = false;
                    }
                })
                .catch(() => {
                    this.loadingReferencias = false;
                });
        },
        changePage(page) {
            if (
                page > 0 &&
                page <= this.pagination.totalPages &&
                page !== this.page
            ) {
                this.page = page;
                this.getReferencias();
            }
        },
        redirectReferencias(id) {
            this.$router.push({
                path: `/dashboard/referenciamentos/edit/${id}`,
                query: { familia_id: this.$route.query.familia_id },
            });
        },
        getFamilia() {
            axios
                .get("api/dashboard/familias/" + this.$route.params.id)
                .then((response) => {
                    this.familia = response.data.data;
                    this.$route.query.familia_id = this.familia.id;
                    this.loading = false;
                })
                .catch(() => {
                    this.$router.push("/dashboard/familias");
                });
        },
        getStatus() {
            axios
                .get(`api/dashboard/status/referenciamentos`)
                .then((response) => {
                    this.status = response.data;
                });
        },
        limparFiltros() {
            this.search = "";
            this.filtroPessoas = [];
            this.filtroStatus = null;
            this.filtroDatas = [];
            this.data_inicio = "";
            this.data_fim = "";
            this.getReferencias();
        },
    },
};
</script>
